module.exports = __webpack_public_path__ + "img/codeImg.a5e13b98.jpg";